import { element } from "prop-types";
import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { AppLayout } from "components/app-layout";
import { ROUTES } from "utils/constants";
import "./AppProject.css";

// const dashboardLinks = [
//   {
//     to: ROUTES.PROJECT,
//     label: "PROJECTS",
//   },
//   {
//     to: ROUTES.LIMITS,
//     label: "LIMITS",
//   },
//   {
//     to: ROUTES.ACTIVITIES,
//     label: "ACTIVITIES",
//   },
// ];

const AppProject = () => {
  return (
<>
<Outlet/>
</>
  );
};

AppProject.propTypes = {
  children: element,
};

export default AppProject;
